/**
 * @see https://advantech-curation.visualstudio.com/Marketplace/_wiki/wikis/Marketplace.wiki/830/Search
 */

// [GET] Search

enum EnumSource {
  PRODUCTS = 'Products',
  SOLUTION = 'Solution',
  EVENTS = 'Events & Webinars',
  RESOURCES = 'Resources',
}

enum EnumType {
  VIDEO = 'Video',
  CASE_STUDY = 'Case Study',
  NEWS = 'News',
  ECATALOG = 'eCatalog',
  INDUSTRY_FOCUS = 'Industry Focus',
  WEBINARS = 'Webinars',
}

interface ISearchItem {
  title: string;
  description: string | null;
  source: EnumSource;
  type: string | null;
  pageUrl: string;
  imageUrl: string | null;
  hasPricingPlan: boolean;
  startTime: string | null;
  timeZone: string | null;
}

interface ISearch {
  pageIndex: number;
  pageSize: number;
  totalCount: number;
  items: ISearchItem[];
}

export { EnumSource, EnumType };
export type { ISearch, ISearchItem };
